// extracted by mini-css-extract-plugin
export default {"container":"container___FWX3Z","group":"group___xJ56k","no-space":"no-space___foAxV"};